import { TextField } from '@efexteam/components';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { FormControl, IconButton } from '@mui/material';
import { ChangeEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface ISearchTools {
  onChange: (item: any) => void;
}

const SearchTools = ({ onChange }: ISearchTools) => {
  const { t } = useTranslation();

  const [searchName, setSearchName] = useState<string | undefined>(undefined);

  const clearSearch = () => {
    setSearchName(undefined);
    onChange(undefined);
  };

  return (
    <FormControl
      fullWidth
      className="!flex !flex-row !gap-2 !items-end !justify-between"
    >
      <TextField
        fullWidth
        id="search-bar"
        type="text"
        value={searchName || ''}
        label={t('search') || ''}
        onInput={(e: ChangeEvent<HTMLInputElement>) => {
          setSearchName(e.target.value);
        }}
        slotProps={{
          input: {
            endAdornment: (
              <>
                <IconButton
                  onClick={() => onChange(searchName)}
                  disabled={!searchName}
                  type="button"
                  color="primary"
                  aria-label="search"
                  size="small"
                >
                  <SearchIcon />
                </IconButton>
                {searchName && (
                  <IconButton
                    color="error"
                    onClick={clearSearch}
                    aria-label="clear search"
                  >
                    <ClearIcon />
                  </IconButton>
                )}
              </>
            ),
          },
        }}
      />
    </FormControl>
  );
};

export default SearchTools;
